import { Navigate } from "react-router-dom";
import { getRole, } from "./session";


const RoleProtectedRoute = ({ children, roles }) => {
  const storedUser = getRole()


  const role = storedUser
    ? storedUser[0]
    : null;


  if (!role) {
   sessionStorage.clear();
    return <Navigate to="/status/404" replace />;
  }

  if (!roles.includes(role)) {
   sessionStorage.clear();
    return <Navigate to="/status/404" replace />;
  }

  return children;
};

export default RoleProtectedRoute;